
import { defineComponent } from "vue";

export default defineComponent({
  name: "DivisorView",
  props: {
    withArrowDown: {
      type: Boolean,
      default: false
    }
  }
});
